import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-41b42874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup_box contents__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_box" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Export")
], -1))
const _hoisted_4 = { class: "option_box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Select image", -1))
const _hoisted_6 = { class: "option_wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio_btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "X-ray Image", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio_btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Analysis Image", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "File extension", -1))
const _hoisted_14 = { class: "option_wrapper" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio_btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Dicom file", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio_btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "PNG file", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "close_icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePopup()))
      }),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["option image", {active: _ctx.target=='origin'}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.target='origin'))
            }, _hoisted_9, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["option image anal", [{active: _ctx.target=='prediction'}, {clickable: !_ctx.singleImg}]]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTarget('prediction')))
            }, _hoisted_12, 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["option extension", {active: _ctx.format=='dcm'}]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.format='dcm'))
            }, _hoisted_17, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["option extension", {active: _ctx.format=='png'}]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.format='png'))
            }, _hoisted_20, 2)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn__default gray",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleExportClick()))
        }, "Export")
      ])
    ])
  ]))
}